import { useContext } from 'react';

import { TimeseriesZoomRangesContext } from '../context/TimeseriesZoomRanges.context.js';

export const useTimeseriesZoomRanges = () =>
  useContext(TimeseriesZoomRangesContext);
